/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'state_lift': {
    width: 16,
    height: 16,
    viewBox: '0 0 61.17 61.17',
    data: '<g data-name="图层 2"><g data-name="图层 1" _fill="#df4545"><path pid="0" d="M30.59 0a30.59 30.59 0 1030.58 30.59A30.62 30.62 0 0030.59 0zm0 60.17a29.59 29.59 0 1129.58-29.58 29.62 29.62 0 01-29.58 29.58z"/><path pid="1" d="M16.74 16.57a.5.5 0 00-.5.5v27a.5.5 0 001 0v-27a.5.5 0 00-.5-.5zM44.43 16.57a.5.5 0 00-.5.5v27a.5.5 0 001 0v-27a.5.5 0 00-.5-.5zM20.43 22.48v17.41a2.3 2.3 0 002.29 2.29h7.17v-22h-7.17a2.3 2.3 0 00-2.29 2.3zM38.06 20.19h-7.17v22h7.17a2.3 2.3 0 002.29-2.29V22.48a2.3 2.3 0 00-2.29-2.29z"/></g></g>'
  }
})
